export default [
  {
    title: 'Konten',
    customicon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g transform="scale(1.5)">
    <path d="M4.83999 1.33334H11.1533C11.5867 1.33334 11.9733 1.34669 12.32 1.39336C14.1667 1.60003 14.6667 2.46668 14.6667 4.84002V9.05336C14.6667 11.4267 14.1667 12.2933 12.32 12.5C11.9733 12.5467 11.5933 12.56 11.1533 12.56H4.83999C4.40665 12.56 4.01999 12.5467 3.67332 12.5C1.82665 12.2933 1.32666 11.4267 1.32666 9.05336V4.84002C1.32666 2.46668 1.82665 1.60003 3.67332 1.39336C4.01999 1.34669 4.40665 1.33334 4.83999 1.33334Z" stroke="#0A0A0A" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.05322 5.54669H11.5066" stroke="#0A0A0A" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.49341 9.40668H4.50673H11.5134" stroke="#0A0A0A" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.66675 14.6667H11.3334" stroke="#0A0A0A" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.79647 5.53335H4.80246" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.99642 5.53335H7.00241" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </svg>
    `,
    resource: 'Konten',
    route: 'konten',
    action: 'manage',
    children: [
      {
        title: 'Buat Konten',
        icon: 'None',
        resource: 'Buat Konten',
        route: 'create-content',
        action: 'manage',
      },
    ],
  },
]
